"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PEPLabels = /*#__PURE__*/function () {
  /**
   * Parses dictionary items passed to a PEPComponent in the markup from Sitecore.
   * @param {HTMLElement} component
   * @constructor
   */
  function PEPLabels(component) {
    _classCallCheck(this, PEPLabels);

    /**
     * @type {Object.<string, string>}
     * @private
     */
    this.labels = function () {
      var labels = {};
      var dictionary = Array.from(component.querySelectorAll('.dictionary *'));
      dictionary.forEach(function (item) {
        labels[item.getAttribute('class')] = item.textContent;
      });
      return labels;
    }();
  }
  /**
   * Returns the value for *key*. If no value exists, returns *key*
   * @param {string} key
   * @returns string
   */


  _createClass(PEPLabels, [{
    key: "getLabel",
    value: function getLabel(key) {
      return this.labels[key] || key;
    }
    /**
     * Returns a key/value object of all known labels for the current component
     * @returns {Object.<string, string>}
     */

  }, {
    key: "getAllLabels",
    value: function getAllLabels() {
      return this.labels;
    }
  }]);

  return PEPLabels;
}();

var _default = PEPLabels;
exports["default"] = _default;